import { cursorPaginationFieldPolicy } from '../../../utils/policies/cursorPaginationFieldPolicy';
import type { TypePolicies } from '../../../utils/types/TypePolicies';

export const typePolicies: TypePolicies = {
  AgentChat: {
    fields: {
      messages: cursorPaginationFieldPolicy(
        false,
        false,
        (node) => node.externalId
      ),
    },
  },
};
